// Module
var code = "<template> <require from=\"app/cm/components/household/services/household-case-services-grid\"></require> <household-case-services-grid household-case-id.bind=\"householdCaseId\"></household-case-services-grid> </template> ";
// Exports
module.exports = code;